// extracted by mini-css-extract-plugin
export var sidebarContainer = "SidebarContainer-module--sidebar-container--6ec2f";
export var sidebarContainerButton = "SidebarContainer-module--sidebar-container-button--8306f";
export var sidebarContainerClose = "SidebarContainer-module--sidebar-container-close--86d3c";
export var sidebarContainerContentWrapper = "SidebarContainer-module--sidebar-container-content-wrapper--1c062";
export var sidebarContainerOpen = "SidebarContainer-module--sidebar-container-open--fc603";
export var sidebarContainerScrollContainer = "SidebarContainer-module--sidebar-container-scroll-container--3dce9";